import { type CSSProperties, ReactNode } from 'react';
import { MotionStyle } from 'framer-motion';

interface TextProps {
    children: ReactNode,
    style?: CSSProperties,
    initial?: boolean,
}

function TextWrapper(props: TextProps) {
    return (
        <div
            style={{
                position: 'absolute',
                whiteSpace: 'pre-line',
                ...props?.style,
            }}
        >
            {props.children}
        </div>
    );
}

export default TextWrapper;
